import { Flex } from '@chakra-ui/react';
import React from 'react';

import type { TChainIndicator } from './types';

import ChainIndicatorItem from './ChainIndicatorItem';

interface Props {
  indicators: Array<TChainIndicator>;
  isLoading: boolean;
}

const ChainIndicatorsList = ({ indicators, isLoading }: Props) => {
  if (indicators.length === 0) {
    return null;
  }

  return (
    <Flex
      flexShrink={ 0 }
      flexDir={{ base: 'row', lg: 'column' }}
      as="ul"
      borderRadius="lg"
      gap={ 2 }
      w="100%"
      justifyContent="space-between"
    >
      { indicators.map((indicator) => {
        return (
          <ChainIndicatorItem
            key={ indicator.id }
            indicator={ indicator }
            isLoading={ isLoading }
          />
        );
      }) }
    </Flex>
  );
};

export default React.memo(ChainIndicatorsList);
